<template>
  <div class="object vacancy-module col-span-full flex flex-col gap-8 md:col-span-7">
    <div class="object__wrapper container">
      <div class="object__flex object__max-grid">
        <Loader v-if="showLoader" class="object__loader"/>


        <router-link
          v-if="isOffer || isNoteOfInterest"
          :to="{ path: '/erbjudanden' }"
          class="mb-2 font-bold"
        >
          Tillbaka
        </router-link>
        <div class="object__image">
          <div
            class="image-wrapper"
            v-if="objectType == RENTALOBJECT_TYPES.APARTMENT"
            :class="!!fullScreenImage ? 'fullscreen' : ''"
          >
            <button class="x-mark-the-spot" @click="fullScreenImage = false">×</button>
            <button
              v-if="onlyImages.length > 1"
              type="button"
              name="button"
              class="prev-image"
              @click="toggleImage(false)"
            >
              <span></span>
            </button>
            <div
              class="image-container image-container-vacancy"
              id="image-module"
              v-if="!showLoader"
            >
              <figure
                v-for="(img, index) in onlyImages"
                :key="{ index }"
                :class="currentImage === index ? 'current-image' : ''"
                :style="'background-image: url(' + img.url + ')'"
              >
                <img
                  :src="img.url"
                  class="visually-hidden"
                  :alt="img.typeCaption + ' ' + address"
                />
              </figure>
            </div>
            <button
              v-if="onlyImages.length > 1"
              type="button"
              name="button"
              class="next-image"
              @click="toggleImage(true)"
            >
              <span></span>
            </button>

            <div v-if="onlyImages.length > 0" class="object__image__navicons">
              <div
                v-for="(img, index) in onlyImages"
                :class="currentImage === index ? 'image-active' : ''"
              ></div>
            </div>
          </div>
          <Map
            v-if="objectType != RENTALOBJECT_TYPES.APARTMENT"
            :isSingle="true"
            class="map"
            v-bind:single="_rentalObject"
            v-bind:singleLongitude="longitude"
            v-bind:singleLatitude="latitude"
            v-bind:objecttype="objectType"
          />

          <div class="object__contents--main">
            <div>
              <div class="object__heading">
                <h1 class="font-neue-kabel">
                  <span v-if="staircase">{{ address }},</span>
                  <span v-if="!staircase">{{ address }}</span>
                  <span v-if="staircase && staircase != 'BV'">våning {{ staircase }}</span>
                  <span v-if="staircase == 'BV'">{{ staircase }}</span>
                </h1>
                <div
                  v-if="subtypeCaption"
                  class="rental-marker desktop-only"
                  :class="subtypeCaptionClass"
                >
                  {{ subtypeCaption }}
                </div>
                <div
                  v-if="
                    subCaption &&
                    (objectType == RENTALOBJECT_TYPES.PARKING ||
                      objectType == RENTALOBJECT_TYPES.PREMISE)
                  "
                  class="rental-marker desktop-only"
                  :class="subtypeCaptionClass"
                >
                  {{ subCaption }}
                </div>
              </div>
              <p class="object__contents--neighbourhood">{{ neighbourhood }}</p>
            </div>
          </div>
        </div>

        <div class="object__contents--secondary">
          <div>
            <div class="object__divider">
              <div
                class="object__flex object__info"
                v-if="objectType == RENTALOBJECT_TYPES.APARTMENT"
              >
                <div v-if="subCaption">{{ subCaption }}</div>
                <div v-if="quantityBRA">{{ quantityBRA }} m²</div>
                <div v-if="monthRent">{{ addSpace(monthRent) }} kr</div>
              </div>

              <div
                class="object__flex object__info"
                v-if="
                  objectType == RENTALOBJECT_TYPES.PARKING ||
                  objectType == RENTALOBJECT_TYPES.PREMISE
                "
              >
                <div v-if="parkingNumber">Platsnummer {{ parkingNumber }}</div>
                <div v-if="quantityBRA && objectType != RENTALOBJECT_TYPES.PARKING">
                  {{ quantityBRA }} m²
                </div>
                <div v-if="monthRent">
                  {{ addSpace(getPrice(monthRent, vatArea, vatAdded, realEstateObjectTypeCode)) }}
                  kr
                </div>
              </div>

              <div class="vacancy-module__drawings">
                <button
                  class="vacancy-module__btn--plan btn desktop-only"
                  v-if="blueprint && objectType == RENTALOBJECT_TYPES.APARTMENT"
                  @click="showBlueprint = true"
                >
                  Visa planlösning
                </button>
                <button
                  class="vacancy-module__btn--plan3d btn desktop-only"
                  v-if="
                    blueprint3d &&
                    blueprint3d.length > 0 &&
                    objectType == RENTALOBJECT_TYPES.APARTMENT
                  "
                  @click="showBlueprint3d = true"
                >
                  Visa 3d-ritning
                </button>
              </div>

              <div class="object__vacantInfo">
                <!--  Särskild inforamtion för husvagnsplatser och MC garage  -->
                <div class="object__extra" v-if="isCar()">
                  <p>{{ infoText(vatArea) }}</p>
                </div>

                <!--/* Särskild inforamtion för husvagnsplatser och MC garage */ -->

                <div
                  class="object__extra"
                  v-if="
                    objectType == RENTALOBJECT_TYPES.PARKING &&
                    ['PPHUSV', 'BILPL1'].indexOf(_rentalObject.rentalObjectTypeCode) !== -1 &&
                    _rentalObject.subtypeCaption &&
                    _rentalObject.subCaption.includes('Motorcykel')
                  "
                >
                  <p v-html="webapp_config.msg.vacancy_object_info_mchusvagn" />
                </div>

                <!--  Särskild inforamtion för båtplats  -->
                <div
                  class="object__extra"
                  v-if="
                    objectType == RENTALOBJECT_TYPES.PARKING &&
                    _rentalObject.rentalObjectTypeCode === 'BÅTPL'
                  "
                >
                  <p v-html="webapp_config.msg.vacancy_object_info_batplats" />
                </div>
              </div>

              <div class="object__flex object__flex--spacebetween">
                <div>
                  <div
                    v-if="subtypeCaption"
                    class="rental-marker mobile-only"
                    :class="subtypeCaptionClass"
                  >
                    {{ subtypeCaption }}
                  </div>
                  <div
                    v-if="
                      subCaption &&
                      (objectType == RENTALOBJECT_TYPES.PARKING ||
                        objectType == RENTALOBJECT_TYPES.PREMISE)
                    "
                    class="rental-marker mobile-only"
                    :class="subtypeCaptionClass"
                  >
                    {{ subCaption }}
                  </div>
                </div>
                <div class="vacancy-module__drawings">
                  <button
                    class="mobile-only vacancy-module__btn--plan btn"
                    v-if="blueprint && objectType == RENTALOBJECT_TYPES.APARTMENT"
                    @click="showBlueprint = true"
                  >
                    Visa planlösning
                  </button>
                  <button
                    class="mobile-only vacancy-module__btn--plan3d btn"
                    v-if="
                      blueprint3d &&
                      blueprint3d.length > 0 &&
                      objectType == RENTALOBJECT_TYPES.APARTMENT
                    "
                    @click="showBlueprint3d = true"
                  >
                    Visa 3d-ritning
                  </button>
                </div>
              </div>

              <div class="object__vacantInfo">
                <div class="object__flex" v-if="publishedTo">
                  <span>Intresseanmäl senast:</span>
                  <span>{{ formatDate(publishedTo, 'YYYY-MM-DD') }}</span>
                </div>
                <div v-if="!isOffer" class="object__flex">
                  <span>Tillträde:</span>
                  <span>{{ vacantFromText }}</span>
                </div>
              </div>

              <div class="object__flex object__info object__info__temporary" v-if="flexibleAccess">
                <h4>Flexibel inflyttning</h4>
                <p>
                  Vi tillämpar flexibel inflyttning på all vår nyproduktion. Det innebär att vi i
                  största möjliga mån försöker möta dina önskemål gällande inflyttningsdatum.
                </p>
              </div>

              <div
                class="object__flex object__info object__info__temporary"
                v-if="
                  _rentalObject &&
                  _rentalObject.rentalObjectTypeCode &&
                  _rentalObject.rentalObjectTypeCode == 'LGH6'
                "
              >
                <h4>Rivningskontrakt</h4>

                <p v-if="!displayTemporary">
                  Den här bostaden finns i ett hus som Gavlegårdarna kommer att riva, därför erbjuds
                  bostaden via ett så kallat rivningskontrakt.
                  <button @click="toggleTemporary()">Läs mer</button>
                </p>

                <div v-if="displayTemporary">
                  <p>
                    Den här bostaden finns i ett hus som Gavlegårdarna kommer att riva, därför
                    erbjuds bostaden via ett så kallat rivningskontrakt. Det innebär att du som
                    längst kommer kunna bo i den här bostaden till och med den 2024-12-31, med
                    eventuell möjlighet till förlängning.
                  </p>
                  <p>
                    Bostaden hyrs ut via marknadsplatsen Direkt och "först till kvarn" gäller, dvs
                    att erbjudande om visning skickas till den som anmäler intresse först.
                  </p>
                  <p>
                    Du behåller dina köpoäng och här kan du läsa mer om
                    <a
                      target="_blank"
                      href="https://www.gavlegardarna.se/hyra-och-bo/for-dig-som-ska-flytta-till-gavlegardarna/rivningskontrakt/"
                    >
                      rivningskontrakt
                    </a>
                    samt om vad som
                    <a
                      target="_blank"
                      href="https://www.gavlegardarna.se/vi-bygger/nybyggnationer/harbo-farbo-och-tradgardsvagen-forandras/"
                    >
                      planeras i det här området i framtiden.
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div class="object__section object__section--list" v-if="rentProperties.length">
              <h3 class="text-b3 font-bold font-neue-kabel" v-if="objectType == RENTALOBJECT_TYPES.APARTMENT">Om bostaden</h3>
              <h3 class="text-b3 font-bold font-neue-kabel" v-if="objectType == RENTALOBJECT_TYPES.PARKING">Om fordonsplatsen</h3>
              <h3 class="text-b3 font-bold font-neue-kabel" v-if="objectType == RENTALOBJECT_TYPES.PREMISE">Om förrådet</h3>
              <div v-if="rentProperties.length" class="object__columns">
                <ul v-for="col in rentPropertiesComputed" class="object__list">
                  <li v-for="item in col" v-bind:key="item.caption">{{ item.caption }}</li>
                </ul>

              </div>
            </div>

            <!-- webNotesRentalObject &&  webNotesRealEstate -->
            <div
              class="object__section object__section--list"
              v-if="
                webNotesRentalObject.length > 0 || webNotesRealEstate.length > 0 || texts.length > 0
              "
            >
              <h3 v-if="objectType == RENTALOBJECT_TYPES.APARTMENT" class="text-b3 font-bold font-neue-kabel">Om fastigheten</h3>
              <h3 v-else class="text-b3 font-bold">Mer information</h3>

              <div v-if="texts.length" class="object__columns">
                <ul v-for="col in textsComputed" class="object__list">
                  <li v-for="(text, index) in col" v-bind:key="index">
                    <span v-if="text && text.value">{{ removeUglyChars(text.caption) }}: {{ text.value }}</span>
                  </li>
                </ul>
              </div>

              <div v-if="objectType == RENTALOBJECT_TYPES.PREMISE">
                I källar- och vindsförråd får du inte förvara några brandfarliga vätskor/gaser.
              </div>

              <div v-if="isCar()">
                <a
                  href="https://www.gavlegardarna.se/parkering-fordonsplatser/forhyrd-fordonsplats/"
                >
                  Läs mer om förhyrda fordonsplatser
                </a>
              </div>

              <div>
                <a href="https://www.gavlegardarna.se/hyr-bostad/vara-omraden/">
                  Läs mer om området
                </a>
              </div>

              <!--<div v-for="note in webNotesRealEstate" v-html="n∫∫ote"></div>-->
            </div>

            <aside class="object__aside mobile-only">
              <div class="grid">
                <div v-if="!isOffer && !isNoteOfInterest" class="grid-xs-12">
                  <CreateNoteOfInterest
                    v-if="rentalObjectCode"
                    :typeCaption="typeCaption"
                    :objectType="objectType"
                    :rentalObjectCode="rentalObjectCode"
                    :authStatus="authStatus"
                    :numberOfApplications="numberOfApplications"
                    :queueText="queueText"
                  />

                  <ApplyInfo :objectCodeInfo="objectCodeInfo" />
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
      <aside v-if="!isOffer && !isNoteOfInterest" class="object__aside desktop-only">
        <div class="grid">
          <div>
            <CreateNoteOfInterest
              v-if="rentalObjectCode"
              :typeCaption="typeCaption"
              :objectType="objectType"
              :rentalObjectCode="rentalObjectCode"
              :authStatus="authStatus"
              :numberOfApplications="numberOfApplications"
              :queueText="queueText"
              :subtypeCaption="subtypeCaption"
            />

            <ApplyInfo :objectCodeInfo="objectCodeInfo" />
          </div>
        </div>
      </aside>
    </div>

    <!-- Hitta hit -->
    <div v-if="objectType == RENTALOBJECT_TYPES.APARTMENT">
      <h2 class="text-b3 font-bold font-neue-kabel mb-4">Hitta hit</h2>
      <div class="map">
        <Map
          :isSingle="true"
          v-bind:single="_rentalObject"
          v-bind:singleLongitude="longitude"
          v-bind:singleLatitude="latitude"
          v-bind:objecttype="objectType"
        />
      </div>
    </div>

    <!-- Planritning -->
    <Modal v-if="showBlueprint" size="lg" @cancel="closeModal()" :hasClose="true">
      <div class="vacancy-module__blueprint__wrapper">
        <p
          class="vacancy-module__blueprint__text"
          v-html="webapp_config.msg.infotext_before_blueprint"
        ></p>
        <img :src="blueprint" class="vacancy-module__blueprint__img" />
      </div>
    </Modal>

    <!-- Planritning 3d -->
    <Modal v-if="showBlueprint3d" size="lg" @cancel="closeModal()">
      <div class="vacancy-module__blueprint__wrapper">
        <p
          class="vacancy-module__blueprint__text"
          v-html="webapp_config.msg.infotext_before_blueprint"
        ></p>
        <img :src="blueprint3d[0].url" class="vacancy-module__blueprint__img" />
        <img
          v-if="blueprint3d[1].url"
          :src="blueprint3d[1].url"
          class="vacancy-module__blueprint__img"
        />
      </div>
    </Modal>

    <div class="object__contents--more-wrapper">
      <div class="object__contents--more">
        <div class="container">
          <h3 class="text-b3 font-bold font-proxima-nova" v-if="objectType == RENTALOBJECT_TYPES.APARTMENT">Fler bostäder i närheten</h3>
          <h3 class="text-b3 font-bold font-proxima-nova" v-if="objectType == RENTALOBJECT_TYPES.PARKING">Fler parkeringsplatser i närheten</h3>
          <h3 class="text-b3 font-bold font-proxima-nova" v-if="objectType == RENTALOBJECT_TYPES.PREMISE">Fler förråd i närheten</h3>
          <AppendableListSearch
            v-if="relatedObjects.length > 0"
            :list="relatedObjects"
            :page="1"
            :size="4"
            :ky="'rentalObjectCode'"
            :listClass="'object-list'"
            :itemClass="'object-item'"
            :showMore="false"
          >
            <template v-slot:default="{ item }">
              <RentalObjectSearch
                :rentalObject="item"
                :unique="item?.rentalObjectCode"
              />
            </template>
          </AppendableListSearch>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/ui/loader';
import ApplyInfo from '@/components/vacancy/applyinfo';
import GoBackButton from '@/components/ui/gobackbutton';
import NavigationButton from '@/components/vacancy/navigationbutton';
import CreateNoteOfInterest from '@/components/vacancy/noteofinterest_new';
import RentalObjectMixin from '@/mixins/rentalobject';
import GeneralMixins from '@/mixins/general';
import { NOT_A_VACANT_RENTALOBJECT, RENTALOBJECT_TYPES, AUTH_STATUSES } from '@/config/constants';
import { filter, isEmpty, map, orderBy, reject } from 'lodash';
import RentalObjectSearch from '@/components/search/rentalobjectsearch';
import AppendableListSearch from '@/components/ui/appendablelistsearch';
import Map from '@/components/search/map';
import Modal from '@/components/ui/modal';
import { PARKING_FILTER_TYPES } from '@/config/constants';

export default {
  mixins: [RentalObjectMixin, GeneralMixins],
  components: {
    Map,
    Loader,
    CreateNoteOfInterest,
    GoBackButton,
    NavigationButton,
    RentalObjectSearch,
    AppendableListSearch,
    Modal,
    ApplyInfo,
  },
  data() {
    return {
      showBlueprint: false,
      showBlueprint3d: false,
      showLoader: true,
      showMap: false,
      fullScreenImage: false,
      currentImage: 0,
      displayTemporary: false,
      RENTALOBJECT_TYPES,
      AUTH_STATUSES,
    };
  },
  watch: {
    /**
     * Om man går till nästa objekt ska datat hämtas igen.
     */
    '$route.params.id'(to, from) {
      if (to !== from) {
        this.initialize();
      }
    },
  },
  computed: {
    ...mapGetters([
      'publishedVacantApartments',
      'publishedVacantParkings',
      'publishedVacantPremises',
      'publishedVacantStudentApartment',
      'publishedVacantCultivationplots',
      'authStatus',
      'profile',
      'config',
      'webapp_config',
    ]),

    rentPropertiesComputed() {
      if (!this._rentalObject.rentProperties) return;
      const HIDDEN_PROPERTIES = new Set([
        'Dusch - duschkabin', 'Bad och dusch', 'Källarvåning', 'Takvåning', 'Badkar',
        'Mindre garageplats', 'Exklusive varmvatten', 'Varmförråd', 'Sopnedkast',
        'Tvättstuga i huset', 'Återvinningsrum i huset', 'Hel frys', 'Skalskydd',
      ]);
      return this.columns(this._rentalObject.rentProperties.filter(item => item.value !== 0 && !HIDDEN_PROPERTIES.has(item.caption)), 2);
    },

    webNotesRentalObjectComputed() {
      let temp = this.webNotesRentalObject[0].split('.\n').join('\n');
      temp = temp.split(',\n').join(', ');
      temp = temp.split('\n');
      return this.columns(temp, 2); // webNotesRentalObject[0].split('\n');
    },

    textsComputed() {
      let temp = this.texts;

      return this.columns(temp, 2); // webNotesRentalObject[0].split('\n');
    },

    searchtype() {
      return 'bostad';

      switch (this.$route.params.type) {
        case 'bostad':
          return RENTALOBJECT_TYPES.APARTMENT;
        case 'fordonsplatser':
          return RENTALOBJECT_TYPES.PARKING;
        case 'forrad':
          return RENTALOBJECT_TYPES.PREMISE;
        case 'studentbostader':
          return RENTALOBJECT_TYPES.STUDENT_APARTMENT;
        case 'odlingslott':
          return RENTALOBJECT_TYPES.CULTIVATION;
        default:
          return RENTALOBJECT_TYPES.APARTMENT;
      }
    },

    /**
     * Visas sidan som ett objekt för ett erbjudande, eller har man klickat på typ ett objekt under "sök ledigt"
     */
    isOffer() {
      return this.$route.name == 'OfferVacancy';
    },

    relatedObjects() {
      let ACTION = null;
      let res = null;

      if (this.objectType == RENTALOBJECT_TYPES.PREMISE) {
        ACTION = 'getPublishedVacantPremises';
        res = this.publishedVacantPremises;
      } else if (this.objectType == RENTALOBJECT_TYPES.APARTMENT) {
        ACTION = 'getPublishedVacantApartments';
        res = this.publishedVacantApartments;
      } /*else if (this.objectType == RENTALOBJECT_TYPES.CULTIVATION) {
        ACTION = 'getPublishedVacantCultivationplots'
        res = this.publishedVacantCultivation;
      }*/ else {
        ACTION = 'getPublishedVacantParkings';
        res = this.publishedVacantParkings;
      }

      this.$store.cache.dispatch(ACTION).finally(() => {});

      const filtered = reject(res, (item) => {
        if (this.rentalObjectCode == item.rentalObjectCode && this.rentalObjectCode) return true;

        //if (this.vatArea !=  item.neighbourhood && this.vatArea)
        // return true

        if (this.neighbourhood != item.neighbourhood && this.neighbourhood) return true;

        // Passerat alla filter, den ska inte rejectas.
        return false;
      });

      return filtered;
    },

    /**
     * Visas sidan som ett objekt för en intresseanmälan, eller har man klickat på typ ett objekt under "sök ledigt"
     */
    isNoteOfInterest() {
      return this.$route.name == 'NoteOfInterestVacancy';
    },

    // Ärver av mixinen som kollar efter _rentalObject
    _rentalObject() {
      // if(this.isOffer || this.isNoteOfInterest)
      //   return  this.$store.getters.getObjectByObjectCode(this.$route.params.id);

      // return this.$store.getters.getVacantObjectByRentalObjectCode(this.$route.params.id)

      return this.$store.getters.getObjectByObjectCode(this.$route.params.id);
    },

    objectCodeInfo() {
      if (this.subtypeCaptionClass == 'startbo') {
        if (this.webapp_config.msg.note_of_intresest_info_from_admin_startbo)
          return this.webapp_config.msg.note_of_intresest_info_from_admin_startbo;
        return 'Startbo är våra bostäder för unga som inte har fyllt 25 år. Lägenheterna är ettor som ligger centralt i Gävle. Du bor nära shopping, nöjen, bussar och tåg, med en hyra som passar en ung plånbok.';
      } else if (this.subtypeCaptionClass == 'trygghetsboende') {
        if (this.webapp_config.msg.note_of_intresest_info_from_admin_trygghetsboende)
          return this.webapp_config.msg.note_of_intresest_info_from_admin_trygghetsboende;
        return 'Du som fyllt 65 år och där ingen i hushållet är yngre än 55 år kan söka en bostad i våra trygghetsboenden. Som hyresgäst i ett av våra trygghetsboenden har du din egen lägenhet – ett, två eller tre rum och kök, det väljer du själv. Trygghetsboende innebär att du bor i ett boende med extra hög tillgänglighetsanpassning. I boendet finns gemensamhetslokaler där du tillsammans med dina grannar kan umgås och arrangera aktiviteter. I Trygghetsboende finns också en anställd trivselvärd som hjälper till med att samordna och arrangera aktiviteter. Ni har även tillgång till en samlingslokal, gästlägenhet, bastu, relax och uterum. \nMed ett trygghetsboende får du med andra ord din egen lägenhet – plus ett antal mervärden.';
      } else if (this.subtypeCaptionClass == 'femtiofemplus') {
        if (this.webapp_config.msg.note_of_intresest_info_from_admin_femtiofemplus)
          return this.webapp_config.msg.note_of_intresest_info_from_admin_femtiofemplus;
        return '55+ är bostäder för dig som fyllt 55 år och som inte har någon yngre än 45 år boende i hushållet.\n\nDu kan hitta en 55+ bostad i nästan alla våra bostadsområden. Ofta ligger de i ett eget hus för att ge en lugnare boendemiljö. Gemensamma gårdar eller utrymmen för aktiviteter finns i många av husen, däremot inte någon restaurang eller personal.';
      } else if (this.subtypeCaption == 'Studentbostad') {
        if (this.webapp_config.msg.note_of_intresest_info_from_admin_student)
          return this.webapp_config.msg.note_of_intresest_info_from_admin_student;
        return 'Studentbostäder.';
      } else if (this.objectType == RENTALOBJECT_TYPES.APARTMENT) {
        return this.webapp_config.msg.note_of_intresest_info_from_admin_apartment;
      } else return '';
    },
    /**
     * WebNotesRealEstate innehåller html. Som behöver göras om lite för att funka bra rent formmässigt
     */
    notes() {
      if (!this._rentalObject || !this._rentalObject.WebNotesRealEstate) return [];

      return map(this._rentalObject.WebNotesRealEstate, (el) => {
        if (el.indexOf('mailto') == -1) el = el.replace('<a ', '<a class="btn" ');
        else el = el.replace('<p>', '<p class="grid-xs-12">');

        return el;
      });
    },
  },
  methods: {
    isCar() {
      if (this._rentalObject) {
        return (
          PARKING_FILTER_TYPES['CAR'].includes(this._rentalObject.realEstateObjectTypeCode) ||
          PARKING_FILTER_TYPES['CAR'].includes(this._rentalObject.rentalObjectType)
        );
      }
    },

    getPrice(monthRent, vatArea, vatAdded) {
      if (this.isCar()) {
        if (vatAdded != true) {
          return Math.round(monthRent * 1.25);
        }
      }
      return monthRent;
    },

    infoText(vatArea) {

        return 'I kostnaden för fordonsplatsen ingår 25% moms';

    },
    toggleTemporary() {
      this.displayTemporary = !this.displayTemporary;
    },

    removeUglyChars(value) {
      if (value.indexOf('Fintvätt') > -1) value = 'Tvättstuga';
      else if (value.indexOf('Grovtvätt') > -1) value = 'Grovtvätt';

      return value;
    },

    closeModal() {
      document.removeEventListener('keyup', this._keyUpListeners);
      document.querySelector('html').classList.remove('modal-open');
      this.showBlueprint = false;
      this.showBlueprint3d = false;
    },

    columns(items, cols) {
      let columnsArr = [];
      let mid = Math.ceil(items.length / cols);
      for (let col = 0; col < cols; col++) {
        columnsArr.push(items.slice(col * mid, col * mid + mid));
      }
      return columnsArr;
    },

    toggleImage(next) {
      var _current = null;

      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT) {
        _current = this.currentImage === undefined ? 0 : this.currentImage;

        _current = parseInt(_current);
        _current = next ? _current + 1 : _current - 1;
        _current = _current >= this.onlyImages.length ? 0 : _current;
        if (_current < 0 && !next) _current = this.onlyImages.length - 1;
      } else {
        _current = this.currentImage === undefined ? this.onlyImages.length : this.currentImage;

        if (this.currentImage === 'map') {
          _current = next ? -1 : this.onlyImages.length;
        }
        _current = parseInt(_current);
        _current = next ? _current + 1 : _current - 1;
        _current = _current > this.onlyImages.length - 1 ? -1 : _current;
        _current = _current < -1 ? this.onlyImages.length + 1 : _current;

        if (_current == -1) _current = 'map';
      }

      this.currentImage = _current;
    },

    setCurrentImage() {
      //only show map in image gallery for premise and parking
      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT)
        this.currentImage =
          this.currentImage == this.onlyImages.length + 1 || this.currentImage === undefined
            ? this.currentImage
            : this.currentImage;
      else
        this.currentImage =
          this.currentImage == 0 || this.currentImage === undefined ? 'map' : this.currentImage;

      if (this.onlyImages.length == 0 && this.objectType == RENTALOBJECT_TYPES.APARTMENT)
        this.currentImage = 'map';
    },

    initialize() {
      this.showLoader = true;
      // Skrolla alltid till toppen
      window.scroll(0, 0);

      if (this.authStatus === AUTH_STATUSES.LOGGEDIN && (this.isOffer || this.isNoteOfInterest)) {
        // Kolla man försöker nå ett objekt man blivit erbjuden ller gjort intresseanmälan på.
        // Annars skicka en till 404
        return Promise.all([
          this.$store.cache.dispatch('fetchNoteofinterests'),
          this.$store.cache.dispatch('fetchOffers'),
        ])
          .then(() => {
            if (
              this.$store.getters.isRentalObjectCodeCurrentOffer(this.$route.params.id) ||
              this.$store.getters.isRentalObjectCodeNoteOfInterest(this.$route.params.id)
            ) {
              return this.$store.cache.dispatch('fetchSingleRentalObject', this.$route.params.id);
            } else this.$router.replace('/404');
          })
          .finally((result) => {
            this.setCurrentImage();
            this.showLoader = false;
          });
      } else {
        // Man ska inte kunna titta vilket rentalobjekt som helst.
        // Bara objekt som är publicerade
        return Promise.all([
          this.$store.dispatch('fetchVacantObjectByRentalObjectCode', this.$route.params.id), // Hämtar info ang om det är ett publicerat objekt
        ]).finally((result) => {
          this.setCurrentImage();
          this.showLoader = false;
        });
      }
    },
  },

  created() {
    if (!!this.authStatus && (!this.profile || (this.profile && !this.profile.contactCode))) {
      this.$store.dispatch('fetchProfile');
    }

    return this.initialize();
  },
};
</script>


<style lang="scss" scoped>
.btn {
  padding: 12px 28px;
  border-radius: 6px;
  border: solid 1px $abgblue;
  background-color: #fff;
  line-height: 1;
  font-size: 16px;
  color: $abgblue;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s;
  outline: none;
  text-transform: none;
  margin: 8px 0 0 0;

  &:hover, &:active, &:focus {
    border: solid 1px $abghoverblue !important;
    background-color: #fff;
    color: $abghoverblue !important;
  }
}

.realestateInfoBox {
  background-color: $offwhite;
}

.realestateProp {
  margin-top: 0;
}

.vacancy-module {
  position: relative;

  &__drawings {
    display: flex;
    width: 100%;
    flex-direction: column;

    @media (min-width: 1024px) {
      margin-top: 12px;
      flex-direction: row;
    }
  }

  &__blueprint {
    margin-top: 40px;
  }

  &__btn--plan {
    position: relative;
    padding: 12px 50px 12px 28px;
    margin-right: 12px;

    &:after {
      content: ' ';
      width: 24px;
      height: 24px;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-drawing.svg);
      position: absolute;
      right: 19px;
      top: calc(50% - 12px);
    }

    &:hover, &:focus-within {
      background-color: #E6F4F8;
    }
  }

  &__btn--plan3d {
    position: relative;
    padding: 12px 50px 12px 28px;

    &:after {
      content: ' ';
      width: 24px;
      height: 24px;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-3d.svg);
      position: absolute;
      right: 19px;
      top: calc(50% - 12px);
    }

    &:hover, &:focus-within {
      background-color: #E6F4F8;
    }
  }
}

h1, h1 span {
  font-size: 29px;
  line-height: 40px;
  font-weight: bold;
  display: inline-block;

  @media (min-width: 800px) {
    font-size: 35px;
    line-height: 47px;
  }
}


h2, h3 {
  font-size: 23px;
  margin-bottom: 10px;
}

ul li {
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
}

.rental-marker {
  position: relative;
  color: $textcolorgray;
  font-size: 18px;
  padding: 6px 12px;
  border-radius: 2px;
  border: solid 1px $gray;
  background-color: $backgroundcolorwhite;
  display: inline-block;
  margin-top: 8px;

  &.mobile-only {
    margin-top: 0;
    font-size: 14px;
  }
}

.mobile-only {
  display: inline-block;

  @media (min-width: 1024px) {
    display: none;
  }
}

.desktop-only {
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
}

.map {
  position: relative;
}


.object {

  &__loader {
    position: absolute !important;
    left: calc(50% - 28px);
    top: 100px;
    z-index: 1;
  }


  &__wrapper {
    display: flex;
    width: 100%;
    //flex-direction: column;
  }

  &__button {
    text-align: center;
    margin-bottom: 14px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
    color: $abgblue;
    display: block;
    position: relative;

    &:before {
      position: absolute;
      top: 2px;
      left: 0;
      content: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-arrow.svg);
      transform: rotate(180deg);
      width: 24px;
      height: 24px;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  &__top-wrapper {
    flex-direction: column;
  }

  &__max-grid {
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
    position: relative;
  }

  &__heading {
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  &__columns {
    display: flex;
    flex-direction: column;

    @media (min-width: 1024px) {
      flex-direction: row;
    }

    & > ul {
      margin-right: 40px;
    }
  }

  &__flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    line-height: 1.4;

    &--spacebetween {
      align-items: center;
      justify-content: space-between;
    }
  }

  &__image {
    width: 100%;

    @media (min-width: 1024px) {
      width: 100%; //calc(100% - 401px);
    }
  }

  &__extra {
    p {
      position: relative;
      padding-left: 25px;
      font-size: 16px;
    }

    p:before {
      content: ' ';
      width: 18px;
      height: 18px;
      background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-info-object.svg);
      position: absolute;
      left: 0;
      top: 2px;
    }
    p:empty {
      &:before {
        content: unset;

      }
    }
  }

  &__aside {
    width: 100%;

    @media (min-width: 1024px) {
      width: 330px;
      margin-left: 56px;
      min-width: 330px;
    }
  }

  .fixed {
    // position: fixed;
  }

  &__contents {
    &--neighbourhood {
      font-size: 16px;
      letter-spacing: 0.64px;
      font-weight: 500;
      text-transform: uppercase;
      margin-bottom: 22px;
      color: $textcolorblack;
    }

    &--secondary {
      width: 100%;
    }

    &--more-wrapper {
      background-color: $offwhite;
      margin-top: 30px;
      display: flex;
      width: 100%;

      @media (min-width: 768px) {
        margin-top: 71px;
      }
    }

    &--more {
      width: 100%;
      max-width: 100% !important;
      margin-left: 0;
      //padding: 0 25px;

      & > div {
        max-width: 1200px;
      }

      @media (min-width: 768px) {
        //padding: 0 45px;
        padding-top: 55px;
        padding-bottom: 128px;
      }

      @media (min-width: 1330px) {
        padding-left: 0;
      }

    }
  }

  &__vacantInfo {
    margin-top: 12px;

    @media (min-width: 1024px) {
      margin-top: 18px;
      max-width: 400px;
    }

    & > div {
      justify-content: space-between;

      @media (min-width: 1024px) {
        justify-content: flex-start;
      }

      span {
        @media (min-width: 1024px) {
          margin-right: 10px;
        }
      }

      span:last-child {
        font-weight: bold;
      }
    }
  }

  &__list {
    list-style-type: disc;
    list-style-position: outside;
    margin-left: 20px;

    li {
      margin-bottom: 12px;
      font-size: 18px;
      line-height: 28px;
      font-weight: 600;
    }
  }

  &__info {

    & > div {
      border-right: 1px solid $gray;
      padding-right: 16px;
      margin-right: 16px;
      font-size: 18px;

      &:last-of-type {
        border: none;
        font-weight: bold;
      }
    }

    &__temporary {
      background: $abgyellow;
      border-radius: 4px;
      padding: 10px 16px;
      margin-top: 24px;

      p {
        font-style: normal;
        font-size: 18px;
        line-height: 28px;
        transition: all 0.3s;
      }

      h4 {
        margin-top: 5px;
        font-size: 18px;
      }

      button {
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 18px;
        padding: unset;
        background: unset;
        font-weight: unset;
        text-decoration: underline;
        font-family: $sansserif;
      }

      a {
        color: #000;

        &:after {
          display: none;
        }
      }
    }
  }

  &__divider {
    padding-bottom: 34px;
    margin-bottom: 34px !important;
    border-bottom: 2px solid grey;

    @media (min-width: 1024px) {
      width: 100%;
    }

  }

  &__section {
    width: 100%;

    @media (min-width: 1024px) {
      width: 100%; // calc(100% - 401px);
    }

    &--list {
      margin-bottom: 40px;

      @media (min-width: 768px) {
        width: 100%;
      }

      @media (min-width: 1024px) {
        margin-bottom: 56px;
      }
    }
  }

  &__objecCodeInfo {
    font-weight: 200;
    font-size: 18px;
  }

  &__list, &__section {
    a {
      display: inline-flex;
      align-items: center;
      position: relative;
      color: $abgblue;
      text-decoration: none;
      padding-right: 32px;

      &:after {
        content: ' ';
        width: 24px;
        height: 24px;
        margin-left: 6px;
        background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-arrow.svg);
      }
    }
  }
}

.x-mark-the-spot {
  background: rgba(0, 0, 0, .15);
  color: $textcolorwhite;
  font-size: 4em;
  border: 0;
}

.prev-image,
.next-image {
  position: absolute;
  z-index: 3;
  border: 0;
  left: 3px;
  top: calc(50% - 22px);
  outline: none;
  right: 0;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  background-color: $abglightblue;
  cursor: pointer;
  transition: all 0.3s;

  @media (min-width: 800px) {
    left: 13px;
  }

  span {
    border: solid $abgblue;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-225deg);
    -webkit-transform: rotate(-225deg);
  }

  &:hover {
    background-color: $abgblue;

    span {
      border-color: $backgroundcolorwhite;
    }
  }
}

.next-image {
  left: auto;
  right: 3px;

  span {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-left: -2px;
  }

  @media (min-width: 800px) {
    right: 13px;
  }
}

.object__image__navicons {
  display: flex;
  justify-content: center;
  margin-top: 15px;

  & > div {
    border-radius: 50%;
    height: 8px;
    width: 8px;
    background-color: $lightgray;
    margin-right: 10px;

    &.image-active {
      background-color: $gray;
    }
  }
}

.x-mark-the-spot {
  display: none;
}

.image-wrapper {
  position: relative;

  .image-container {
    figure, .map {
      transition: all .4s;
      opacity: 0;

      &.current-image {
        opacity: 1;
      }
    }

    #map-container {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      min-height: 0;
    }
  }

  &.fullscreen {
    .x-mark-the-spot {
      position: fixed;
      z-index: 30005;
      display: block;
      font-size: 4em;
      width: 1em;
      height: 1em;
      top: 0;
      right: 0;
    }

    .prev-image,
    .next-image {
      position: fixed;
    }

    .image-container {
      position: fixed;
      z-index: 30000;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: 0;
      background-color: rgba(0, 0, 0, .8);

      figure {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 90%;
        max-width: 1280px;
        margin: 0 auto;
        background-size: contain;
        background-repeat: no-repeat;
        transition: all .3s;
      }
    }
  }
}

</style>

<style>
[v-cloak] > * {
  display: none
}

#image-module .ol-zoom {
  display: none;
}

</style>
